module.exports = __webpack_public_path__ + "img/mail.24f51501.svg";